import React from 'react';
import './newbackup.css'


function newbackup () {
    
        return (
            <div>
                    <div className="container-fluid">

   <div className="backupMainContainer">

    <h1 className="backupPageTitle">Tạo sao lưu mới</h1>

    <div className="backupBreadcrumbWrapper">
      <span className="backupBreadcrumbText">Trang chủ</span>
      <span className="backupBreadcrumbText">/</span>
      <span className="backupBreadcrumbText">Sao lưu dữ liệu</span>
      <span className="backupBreadcrumbText">/</span>
      <span className="backupBreadcrumbText">Tạo sao lưu mới</span>
    </div>

    {/* <!-- THÔNG TIN SAO LƯU --> */}
    <div className="backupSectionCard">

      <h2 className="backupSectionTitle">Thông tin sao lưu</h2>

      <div className="backupThreeColumnGrid">
{/* 
        <!-- TÊN BẢN SAO LƯU --> */}
        <div className="backupFormGroup">
          <label className="backupInputLabel">
            Tên bản sao lưu <span className="backupRequiredStar">*</span>
          </label>

          <input
            type="text"
            className="backupTextInput"
            placeholder="Nhập tên bản sao lưu..."
          />

          <p className="backupHintText">
            Ví dụ: Backup_20240520_0230
          </p>
        </div>

        {/* <!-- LOẠI SAO LƯU --> */}
        <div className="backupFormGroup">
          <label className="backupInputLabel">
            Loại sao lưu <span className="backupRequiredStar">*</span>
          </label>

          <div className="backupRadioGroupWrapper">

            <label className="backupRadioItem">
              <input
                type="radio"
                name="backupType"
                checked
                className="backupRadioInput"
              />
              <span className="backupRadioText">Tự động</span>
            </label>

            <label className="backupRadioItem">
              <input
                type="radio"
                name="backupType"
                className="backupRadioInput"
              />
              <span className="backupRadioText">Thủ công</span>
            </label>

          </div>
        </div>

        {/* <!-- MÔ TẢ --> */}
        <div className="backupFormGroup">
          <label className="backupInputLabel">
            Mô tả
          </label>

          <textarea
            className="backupTextareaField"
            placeholder="Nhập mô tả cho bản sao lưu (không bắt buộc)..."
          ></textarea>

          <div className="backupTextareaCounter">0/255</div>
        </div>

        {/* <!-- PHƯƠNG THỨC SAO LƯU --> */}
        <div className="backupFormGroup">

          <label className="backupInputLabel">
            Phương thức sao lưu <span className="backupRequiredStar">*</span>
          </label>

          <div className="backupRadioGroupWrapper">

            <label className="backupRadioItem">
              <input
                type="radio"
                name="backupMethod"
                checked
                className="backupRadioInput"
              />
              <span className="backupRadioText">
                Sao lưu đầy đủ (Full backup)
              </span>
            </label>

          </div>

          <p className="backupHintText">
            Sao lưu toàn bộ dữ liệu hệ thống
          </p>

          <div className="backupRadioGroupWrapper">

            <label className="backupRadioItem">
              <input
                type="radio"
                name="backupMethod"
                className="backupRadioInput"
              />
              <span className="backupRadioText">
                Sao lưu gia tăng (Incremental backup)
              </span>
            </label>

          </div>

          <p className="backupHintText">
            Chỉ sao lưu phần dữ liệu thay đổi từ lần sao lưu gần nhất
          </p>

        </div>

        {/* <!-- ĐỘ ƯU TIÊN --> */}
        <div className="backupFormGroup">

          <label className="backupInputLabel">
            Độ ưu tiên
          </label>

          <select className="backupSelectField">
            <option>Bình thường</option>
            <option>Cao</option>
            <option>Thấp</option>
          </select>

          <p className="backupHintText">
            Ưu tiên cao sẽ được thực hiện trước
          </p>

        </div>

        {/* <!-- THỜI GIAN THỰC HIỆN --> */}
        <div className="backupFormGroup">

          <label className="backupInputLabel">
            Thời gian thực hiện
          </label>

          <div className="backupScheduleWrapper">

            <div className="backupRadioGroupWrapper">

              <label className="backupRadioItem">
                <input
                  type="radio"
                  name="scheduleType"
                  checked
                  className="backupRadioInput"
                />
                <span className="backupRadioText">
                  Thực hiện ngay
                </span>
              </label>

            </div>

            <div className="backupRadioGroupWrapper">

              <label className="backupRadioItem">
                <input
                  type="radio"
                  name="scheduleType"
                  className="backupRadioInput"
                />
                <span className="backupRadioText">
                  Lên lịch thực hiện
                </span>
              </label>

            </div>

            <div className="backupScheduleDateBox">

              <input
                type="datetime-local"
                value="2025-05-20T14:30"
                className="backupScheduleInput"
              />

              <span className="backupCalendarIcon">📅</span>

            </div>

            <p className="backupHintText">
              Chọn thời gian bắt đầu sao lưu
            </p>

          </div>

        </div>

      </div>

    </div>

    {/* <!-- PHẠM VI SAO LƯU --> */}
    <div className="backupSectionCard">

      <h2 className="backupSectionTitle">Phạm vi sao lưu</h2>
 <p className="backupHintText" >
            Chọn phạm vi dữ liệu cần sao lưu
          </p>
      <div className="backupThreeColumnGrid">

        {/* <!-- TOÀN BỘ HỆ THỐNG --> */}
        <div className="backupFormGroup">

         

          <div className="backupRadioGroupWrapper">

            <label className="backupRadioItem">
              <input
                type="radio"
                checked
                name="scopeType"
                className="backupRadioInput"
              />
              <span className="backupRadioText">
                Toàn bộ hệ thống
              </span>
            </label>

          </div>

          <p className="backupHintText">
            Sao lưu toàn bộ cơ sở dữ liệu và tệp tin hệ thống
          </p>

        </div>

        {/* <!-- THEO MODULE --> */}
        <div className="backupFormGroup">

          <div className="backupRadioGroupWrapper">

            <label className="backupRadioItem">
              <input
                type="radio"
                name="scopeType"
                className="backupRadioInput"
              />
              <span className="backupRadioText">
                Theo module
              </span>
            </label>

          </div>

          <p className="backupHintText">
            Chọn các module cần sao lưu
          </p>

          <select className="backupSelectField backupModuleSelect">
            <option>Chọn module cần sao lưu...</option>
            <option>Người dùng</option>
            <option>Hệ thống</option>
            <option>Dữ liệu khách hàng</option>
          </select>

        </div>

        {/* <!-- TÙY CHỈNH NÂNG CAO --> */}
        <div className="backupFormGroup">

          <div className="backupRadioGroupWrapper">

            <label className="backupRadioItem">
              <input
                type="radio"
                name="scopeType"
                className="backupRadioInput"
              />
              <span className="backupRadioText">
                Tùy chọn nâng cao
              </span>
            </label>

          </div>

          <p className="backupHintText">
            Tùy chỉnh cơ sở dữ liệu và thư mục
          </p>

          <button className="backupAdvancedButton">
            ⚙️ Cấu hình nâng cao
          </button>

        </div>

      </div>

    </div>

    {/* <!-- LƯU TRỮ SAO LƯU --> */}
    <div className="backupSectionCard">

      <h2 className="backupSectionTitle">Lưu trữ sao lưu</h2>

      <div className="backupThreeColumnGrid">

        {/* <!-- NƠI LƯU TRỮ --> */}
        <div className="backupFormGroup">

          <label className="backupInputLabel">
            Nơi lưu trữ <span className="backupRequiredStar">*</span>
          </label>

          <select className="backupSelectField">
            <option>Máy chủ lưu trữ nội bộ</option>
            <option>Google Drive</option>
            <option>Amazon S3</option>
          </select>

          <p className="backupHintText">
            Chọn nơi lưu trữ bản sao lưu
          </p>

          <div className="backupCheckboxWrapper">

            <input
              type="checkbox"
              checked
              className="backupCheckboxInput"
            />

            <div className="backupCheckboxContent">

              <div className="backupCheckboxTitle">
                Nén dữ liệu sau khi sao lưu
              </div>

              <p className="auto-delete">
                Giảm dung lượng lưu trữ (thời gian sao lưu có thể lâu hơn)
              </p>

            </div>

          </div>

        </div>

        {/* <!-- THƯ MỤC --> */}
        <div className="backupFormGroup">

          <label className="backupInputLabel">
            Thư mục lưu trữ <span className="backupRequiredStar">*</span>
          </label>

          <input
            type="text"
            value="/backup/data"
            className="backupTextInput"
          />

          <p className="backupHintText">
            Đường dẫn thư mục lưu trữ trên máy chủ
          </p>

        </div>

        {/* <!-- THỜI GIAN GIỮ --> */}
        <div className="backupFormGroup">

          <label className="backupInputLabel">
            Thời gian giữ bản sao lưu <span className="backupRequiredStar">*</span>
          </label>

         <div className='time-save'>
             <input
            type="number"
            value="30"
            className="backupTextInput"
          />
          <p className='date'>ngày</p>
         </div>

          <p className="backupHintText">
            Số ngày lưu giữ trước khi tự động xóa
          </p>

        </div>

      </div>

    </div>

    {/* <!-- BUTTON --> */}
    <div className="backupFooterButtonArea">

      <button className="backupCancelButton">
        ✕ Hủy bỏ
      </button>

      <button className="backupCreateButton">
        ✓ Tạo sao lưu
      </button>

    </div>

  </div>


</div>

            </div>
        );
    
}



export default newbackup;